import React, { useState, useEffect } from "react";
import SDClient from "../../../sd_core/client";
import { serValidatePromo, serPromocodeToday } from "../../../services";
import Loader from "../../common/spinner";
import classes from "./checkout-form.module.scss";

const Coupons = (props) => {
  const [discountCode, setDiscountCode] = useState("");
  const [validationTrace, setValidationTrace] = useState({});
  const [applyLoading, setApplyLoading] = useState(false);
  const [viewCoupons, setViewCoupons] = useState(false);
  const [todaysCoupon, setTodaysCoupon] = useState(null);

  useEffect(() => {
    serPromocodeToday().then((res) => {
      const promo = res && res.data && res.data.success && res.data.promocode;
      if (promo && promo.code) setTodaysCoupon(promo);
    });
  }, []);
  const getCouponsList = () => {
    const discountCoupons =
      props &&
      props.VOData &&
      props.VOData.options &&
      props.VOData.options.discount_coupons;

    if (Array.isArray(discountCoupons) && discountCoupons.length > 0) {
      return discountCoupons;
    }

    if (discountCoupons && Object.keys(discountCoupons).length > 0) {
      return Object.values(discountCoupons);
    }

    return [];
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      setViewCoupons(false);
    }
  };

  const bindDiscountCode = (trimmedCode) => {
    SDClient.endpoint("virtual_order_set_discount_code", {
      code: trimmedCode,
    }).then(
      (data) => {
        if (data.message.action) {
          setValidationTrace({
            APPLY_OK: true,
          });
          props.updateVO();
        } else {
          if (data.message.reason == "MESSAGE_VALIDATION_ERROR") {
            setValidationTrace(data.message.trace);
          } else if (data.message.reason == "DISCOUNT_COUPON_NOT_FOUND") {
            setValidationTrace({ DISCOUNT_COUPON_NOT_FOUND: true });
          } else if (data.message.reason == "SUBTOTAL_LESS_THAN_AMOUNT_LIMIT") {
            setValidationTrace({ SUBTOTAL_LESS_THAN_AMOUNT_LIMIT: true });
          }
        }
        setApplyLoading(false);
      },
      // console.log
    );
  };

  const applyDiscountCode = () => {
    const trimmedCode = discountCode.trim();
    if (!trimmedCode) {
      setValidationTrace({ code: true });
      return;
    }
    if (applyLoading) return;
    setApplyLoading(true);
    // Step 1: validate / load the code via order/promo
    serValidatePromo(trimmedCode).then((res) => {
      const ok = res && res.data && res.data.success;
      if (!ok) {
        setValidationTrace({ DISCOUNT_COUPON_NOT_FOUND: true });
        setApplyLoading(false);
        return;
      }
      // Step 2: valid → bind to the virtual order (recalculates totals)
      bindDiscountCode(trimmedCode);
    });
  };

  const clearDiscountCode = () => {
    setApplyLoading(true);
    SDClient.endpoint("virtual_order_clear_discount_code").then(
      (data) => {
        setValidationTrace({});
        setApplyLoading(false);
        props.updateVO();
      },
      // console.log
    );
  };

  const promoCode = () => {
    return (
      <div className={classes.input_wrap}>
        <div className={classes.promoInputGroup}>
          <input
            type="text"
            name="promocodes"
            className={classes.promoInput}
            placeholder="Enter coupon code"
            value={discountCode}
            onChange={(e) => setDiscountCode(e.target.value)}
          />
          {applyLoading ?
            <span className={classes.promoButton}>Applying...</span>
            :
            <button
              type="button"
              className={classes.promoButton}
              onClick={() => applyDiscountCode()}
            >
              Apply
            </button>
          }
        </div>
        {validationTrace.DISCOUNT_COUPON_NOT_FOUND && (
          <p className={classes.promoError}>
            This promocode is not a valid one, please check again.
          </p>
        )}
        {validationTrace.APPLY_OK && (
          <p className={classes.promoSuccess}>
            Promocode has been successfully applied
          </p>
        )}
        {validationTrace.code && (
          <p className={classes.promoError}>
            Please specify a valid promocode.
          </p>
        )}
        {validationTrace.SUBTOTAL_LESS_THAN_AMOUNT_LIMIT && (
          <p className={classes.promoError}>
            This promocode can only be applied on orders above ₹1 Lakh.
          </p>
        )}
      </div>
    );
  };

  const appliedPromoCode = () => {
    if (props.VOData.order.applied_payment_discount) {
      const promoline = () => {
        if (
          props.VOData.order.applied_payment_discount
            .virtual_order_discount_type == "PERCENTAGE"
        ) {
          return (
            "A discount of " +
            props.VOData.order.applied_payment_discount
              .virtual_order_discount_relative_value +
            "% has been applied."
          );
        } else if (
          props.VOData.order.applied_payment_discount
            .virtual_order_discount_type == "FLAT"
        ) {
          return (
            "A flat discount of " +
            props.VOData.order.applied_payment_discount
              .virtual_order_discount_relative_value +
            " has been applied."
          );
        } else {
          return (
            "A flat discount of " +
            props.VOData.order.applied_payment_discount
              .virtual_order_discount_relative_value +
            " will be applied on orders above ₹1 Lakh."
          );
        }
      };
      return (
        <>
          <hr></hr>
          <div className="d-flex justify-content-between">
            <p className="text-secondary text-uppercase">
              Applied Discount Code
            </p>
            <div className="mt-1">{props.syncing ? <Loader /> : ""}</div>
          </div>
          <div className="mb-3 d-flex justify-content-between">
            <div className="m-0">
              <span className="d-inline-flex align-items-center">
                {
                  props.VOData.order.applied_payment_discount
                    .virtual_order_discount_name
                }
                <span
                  uk-icon="icon: trash; ratio: 0.7"
                  className="uk-icon uk-margin-small-left"
                  onClick={clearDiscountCode}
                  style={{ color: "red", cursor: "pointer", position: "relative", top: "-2px" }}
                />
              </span>
              <h6 className="uk-text-success uk-margin-small">{promoline()}</h6>
            </div>
            {/* <button className="uk-button uk-button-primary buy-now uk-align-center uk-margin-remove" onClick={clearDiscountCode}>
              <small>REMOVE</small>
            </button> */}
          </div>
        </>
      );
    }
  };

  const setCouponFromList = (couponCode) => {
    setDiscountCode(couponCode);
    setViewCoupons(false);
  };

  const todaysCouponLabel = () => {
    if (todaysCoupon.type == "PERCENTAGE") {
      return "Get " + todaysCoupon.value + "% off your order.";
    }
    return "Get a flat discount of " + todaysCoupon.value + " on your order.";
  };

  const featuredCoupon = () => {
    if (!todaysCoupon || !todaysCoupon.code) return null;
    return (
      <div className={`${classes.couponCard} ${classes.couponFeatured}`}>
        <div className={classes.couponFeaturedBadge}>Today's offer</div>
        <div className={classes.couponTopRow}>
          <div className={classes.couponCode}>{todaysCoupon.code}</div>
          <button
            type="button"
            className={classes.couponCopyBtn}
            onClick={() => setCouponFromList(todaysCoupon.code)}
          >
            Copy
          </button>
        </div>
        <div className={classes.couponLabel}>{todaysCouponLabel()}</div>
      </div>
    );
  };

  const showCoupons = () => {
    const featured = featuredCoupon();
    const featuredCode =
      todaysCoupon && todaysCoupon.code
        ? todaysCoupon.code.toUpperCase()
        : null;
    // De-dupe: drop the list entry if it matches today's featured code
    const discountCoupons = getCouponsList().filter(
      (coupon) =>
        !featuredCode ||
        !coupon.code ||
        coupon.code.toUpperCase() !== featuredCode
    );

    if (!featured && !discountCoupons.length) {
      return (
        <div className={classes.couponEmpty}>No coupons available.</div>
      );
    }

    return (
      <>
        {featured}
        {discountCoupons.map((coupon, index) => (
      <div
        className={classes.couponCard}
        key={coupon.code || coupon.label || index}
      >
        <div className={classes.couponTopRow}>
          <div className={classes.couponCode}>
            {coupon.code || "COUPON"}
          </div>
          <button
            type="button"
            className={classes.couponCopyBtn}
            onClick={() => setCouponFromList(coupon.code || "")}
          >
            Copy
          </button>
        </div>
        <div className={classes.couponLabel}>
          {coupon.label || "Discount on your order"}
        </div>
        <div className={classes.couponDesc}>
          {coupon.description || "Valid for a limited time."}
        </div>
      </div>
        ))}
      </>
    );
  };

  const viewApplicablePromocodes = () => {
    if (viewCoupons) {
      return (
        <div className={classes.couponOverlay} onClick={handleOverlayClick}>
          <div
            className={classes.couponSheet}
            role="dialog"
            aria-modal="true"
            onClick={(e) => e.stopPropagation()}
          >
            <div className={classes.couponHeader}>
              <h4 className={classes.couponTitle}>Apply Coupon</h4>
              <button
                type="button"
                className={classes.couponClose}
                aria-label="Close"
                onClick={() => setViewCoupons(false)}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M4 4L12 12M12 4L4 12"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>
            <div className={classes.couponList}>{showCoupons()}</div>
          </div>
        </div>
      );
    }
  };

  const loadPromocodes = () => {
    if (!props.syncing) {
      return appliedPromoCode();
    }
    return null;
  };

  return (
    <div className={classes.promoSection}>
      {props.discountDetails &&
        props.discountDetails.errors &&
        props.discountDetails.errors.map((error, i) => (
          <div className="alert alert-danger" role="alert" key={i}>
            {error.text}
          </div>
        ))}
      <div className={classes.promoTitleRow}>
        <p className={classes.promoTitle}>Coupon Code</p>
        <button
          className={classes.promoLink}
          onClick={() => setViewCoupons(true)}
        >
          View coupons
        </button>
      </div>
      {promoCode()}
      {loadPromocodes()}
      {viewApplicablePromocodes()}
    </div>
  );
};

export default Coupons;
